// ===== Main Colors =====
// Bay of Many
export const mainBlue = "#00367a"
// Emerald
export const mainGreen = "#3dc578"
// Big Stone
export const mainGray = "#102a43"
// Athens Gray
export const mainLightGray = "#f0f4f8"

// ===== Font Colors =====
// Black
export const fontBlack = "#000000"
//  Bay of Many
export const fontBlue = "#00367a"
// White
export const fontWhite = "#ffffff"
// Athens Gray - Dark Shade 02
export const fontGray = "#b2b7bd"

// ===== Secondary Colors =====
export const lightBlue = "#2aa4dc"
export const mediumLightBlue = "#147ec2"
export const mediumBlue = "#0858a0"
